import Layout from "components/layout/Layout";
import Roadmap from "../components/layout/roadmap/Roadmap";

const Work = () => {
  return (
    <Layout
      headerStyle={1}
      footerStyle={1}
      breadcrumbTitle={
        <>
          {" "}
          How it <span>works</span>
        </>
      }
    >
      <Roadmap />
    </Layout>
  );
};
export default Work;
